export default __webpack_public_path__ + "static/media/img-cyln-full-face.689807ba.png";